"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopPageSubscriptionListDisplay = ShopPageSubscriptionListDisplay;
const react_1 = __importDefault(require("react"));
const shop_page_subscription_display_1 = require("./shop-page-subscription-display");
function ShopPageSubscriptionListDisplay({ subscriptionList }) {
    let loyaltyCount = subscriptionList ? subscriptionList.length : 0;
    const panelClass = (loyaltyCount > 1) ? "subscription_loyalty_panel_2x" : "subscription_loyalty_panel_1x";
    return react_1.default.createElement("div", { className: panelClass }, subscriptionList === null || subscriptionList === void 0 ? void 0 : subscriptionList.map((subscription) => react_1.default.createElement(shop_page_subscription_display_1.ShopPageSubscriptionDisplay, { subscription: subscription, loyaltyCount: loyaltyCount, key: subscription.subscriptionName })));
}
